<template>
  <div class="evaluation-viewer-view">
    <evaluation-viewer-base
      :evaluation="evaluation"
      :branch="branch"
      :dealer="dealer"
    />
  </div>
</template>

<script>
import EvaluationViewerBase from '@/modules/evaluation-viewer/evaluation-viewer-base'

/**
   * 'EvaluationViewer' Component
   * @version 1.0.0
   * @author Fernando Torres
   * @copyright Marciano Studio S.C., 2018
   */
export default {
  name: 'EvaluationViewerView',
  components: {EvaluationViewerBase},
  computed: {
    branch () {
      return this.evaluation.branch
    },
    evaluation () {
      return this.$store.getters['evaluations/item']
    },
    dealer () {
      return this.$store.getters['dealers/item']
    }
  }
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style lang="scss" scoped>
    .evaluation-viewer-view {

    }
</style>



// WEBPACK FOOTER //
// src/views/evaluation/evaluation-viewer.view.vue